'use client';

import { isBrowser } from '@lib/environment/isBrowser';
import { ClickableVariant } from '../Clickables/variants';
import { Button } from '../Clickables/Buttons/Button';

interface IProps {
  className?: string;
  variant?: ClickableVariant;
}

export const CookiePreferencesLink = ({
  className = 'body-text-md',
  variant = 'textDeprecatedLight',
}: IProps) => {
  return (
    <Button
      aria-label="cookie-preferences"
      onClick={() => {
        if (isBrowser()) {
          window.Osano?.cm?.showDrawer();
        }
      }}
      variant={variant}
      className={className}
    >
      Cookie preferences
    </Button>
  );
};
